import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Plus, Eye, Pen, Gear } from "react-bootstrap-icons";
import { MdDelete } from "react-icons/md";
import DataTable from "react-data-table-component";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  handleAddPreauthorizationServices,
  resetSelectedService,
  setHistoryModal,
  setSelectedService,
  setViewModal,
} from "../config/preauthorizationSlice";
import { GetAllServiceCodeDescription } from "../config/preauthorizationApi";
import { useSearchParams } from "react-router-dom";

const ServicesProcedures = () => {
  const dispatch = useDispatch();
  const {
    servicesList,
    viewPreauthorizationInfo,
    practitionerListAdded,
    bodySite,
    oralDentalList,
    labTestList,
    routeList,
    scientificAbsnceReason,
    selectReasonList,
    bodySubSite,
    substituteReason,
    serviceTypeList,
    stepFormData,
  } = useSelector((state) => state.preauthorization);

  const servRef = useRef();

  console.log({ practitionerListAdded });

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const [searchParams] = useSearchParams();
  const reuse = searchParams.get("reuse") === "true";
  const edit = searchParams.get("edit") === "true";
  const followUp = searchParams.get("followup") === "true";

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Get service procedures from the preauth response

  console.log({ viewPreauthorizationInfo });

  const providerServices =
    viewPreauthorizationInfo?.provider_request?.service_procedures || [];

  const daySupplyInfo =
    viewPreauthorizationInfo?.provider_request?.sup_info_suply;

  useEffect(() => {
    if (
      !providerServices?.length ||
      servRef.current ||
      (!reuse && !edit && !followUp)
    ) {
      return;
    }

    servRef.current = true;

    console.log({ selectReasonList });

    const loadServices = async () => {
      try {
        const transformed = await Promise.all(
          providerServices?.map(async (item, index) => {
            const dosageData = item?.medication_request?.dosage_instruction;
            const duration = dosageData?.duration?.split("-");
            const frequency = dosageData?.frequency?.split(" ");
            const freqDetails = frequency?.[0]?.split("-");
            const doseDetails = dosageData?.dose?.split(" ");
            let medicationRequest = null;
            const netAmount = parseFloat(item.servinfo_prdnamnt || 0);
            const patientShare = parseFloat(item.servinfo_prdpshre || 0);
            const unitPrice = parseFloat(item.servinfo_prdpri || 0);
            const quantity = parseFloat(item.servinfo_prdqty || 1);
            const discount = parseFloat(item.servinfo_prddisc || 0);

            const selectedCodes = item?.servinfo_suprt2?.split(","); // ["100000-9", "78001-5"]

            const selectedItems = labTestList?.filter((t) =>
              selectedCodes?.includes(t?.lab_test_code?.loinc_code)
            );

            console.log({ selectedItems });

            const response = await dispatch(
              GetAllServiceCodeDescription({
                branch_id:
                  selectedBranch?.branch_id || selectedBranch?.value || "",
                prd_typ: item?.prdtypcde,
                prodserv_id: item?.itemcode,
                ins_sel: stepFormData?.payer?.insurance_company_id,
                claim_type: stepFormData?.preauthorization_type?.claim_types_id,
                is_prescription: stepFormData?.prescription || false,
              })
            ).unwrap();

            if (
              item?.presmed ||
              item?.medication_request?.medicationrequest_code
            ) {
              const res = await dispatch(
                GetAllServiceCodeDescription({
                  branch_id:
                    selectedBranch?.branch_id || selectedBranch?.value || "",
                  prd_typ: "itm_prdt",
                  prodserv_id:
                    item?.presmed ||
                    item?.medication_request?.medicationrequest_code,
                  ins_sel: stepFormData?.payer?.insurance_company_id,
                  claim_type:
                    stepFormData?.preauthorization_type?.claim_types_id,
                  is_prescription: stepFormData?.prescription || false,
                })
              ).unwrap();
              const resServData = res?.data?.Service_Code?.[0] || {};
              medicationRequest = {
                prodserv_code: resServData?.prodserv_code,
                prodserv_desc: resServData?.prodserv_desc,
                provider_code: resServData?.provider_code || "",
                unit_price: resServData?.unit_price || 0,
                price_discount: resServData?.price_discount || 0,
                price_tax: resServData?.price_tax || "15",
                provider_codedesc: resServData?.provider_codedesc || "",
                prdurl: resServData?.prdurl || "",
                prodserv_unittyp: resServData?.prodserv_unittyp || "",
                prodserv_pcksze: resServData?.prodserv_pcksze || "",
                prodserv_strngt: resServData?.prodserv_strngt || "",
                value: resServData?.value,
                label: resServData?.label,
              };
            }

            const servData = response?.data?.Service_Code?.[0] || {};

            return {
              id: `service-${item.itemcode}-${item.dateserv}-${index}`,
              service_start_date:
                item.dateserv || moment().format("YYYY-MM-DD"),
              service_end_date: item.dateserv || moment().format("YYYY-MM-DD"),

              service_type: serviceTypeList?.find(
                (serv) => serv?.servtype_code === item?.prdtypcde
              ),

              service_code_description: {
                prodserv_code: servData?.prodserv_code,
                prodserv_desc: servData?.prodserv_desc,
                provider_code: servData?.provider_code || "",
                unit_price: servData?.unit_price || 0,
                price_discount: servData?.price_discount || 0,
                price_tax: servData?.price_tax || "15",
                provider_codedesc: servData?.provider_codedesc || "",
                prdurl: servData?.prdurl || "",
                prodserv_unittyp: servData?.prodserv_unittyp || "",
                prodserv_pcksze: servData?.prodserv_pcksze || "",
                prodserv_strngt: servData?.prodserv_strngt || "",
                value: servData?.value,
                label: servData?.label,
              },

              quantity,
              unit_price: unitPrice,
              discount,
              patient_share: patientShare,
              net_amount: netAmount,

              vat: item.servinfo_prdtax === "15" ? "15" : "0",

              raw: item,
              lab_tests: selectedItems || [],
              service_practitioner:
                practitionerListAdded?.find(
                  (pract) => pract?.id == item?.servinfo_pract
                )?.practitioner || null,

              diagnosis: item.servinfo_diag
                ? [{ code: item.servinfo_diag, name: item.servinfo_diagname }]
                : [],

              maternity: item.matrnty?.toLowerCase() === "yes",
              body_site: item?.bodysite
                ? bodySite?.find((b) => b?.bodysite_code === item?.bodysite)
                : "",
              sub_site: item?.subsite
                ? bodySubSite?.find(
                  (b) => b?.bodysubsite_code === item?.subsite
                )
                : "",
              oral_origin: item?.toothno
                ? oralDentalList?.find(
                  (tooth) => tooth?.oral_code === item?.toothno
                )
                : "",
              day_supply: daySupplyInfo?.[index]?.qty,
              prescribed_medication_type: serviceTypeList?.find(
                (serv) => serv?.servtype_code === item?.presmedtyp
              ),
              prescribed_medication_code: medicationRequest,
              strength:
                item?.prdtypcde == "itm_prdt" || item?.prdtypcde == "itm_meddev"
                  ? ""
                  : item?.pharstrnth,
              selection_reason: selectReasonList?.find(
                (reason) => reason?.pharmselrsn_code === item?.pharslrsn
              ),
              pharmacist_substitute: substituteReason?.find(
                (sub) => sub?.subsrsn_code === item?.pharsubs
              ),
              scientic_code_absence: scientificAbsnceReason?.find(
                (abs) => abs?.absrsn_code === item?.pharscabrsn
              ),
              scientific_code_other_reason: item?.pharscabrsn_oth || "",
              substitute_reason_other: item?.pharsubs_oth || "",
              route: routeList?.find(
                (route) => route?.ruteadmn_code === dosageData?.route_code
              ),
              start_date: dosageData?.period_start
                ? new Date(dosageData?.period_start)
                : "",
              end_date: dosageData?.period_end
                ? new Date(dosageData?.period_end)
                : "",
              refill_count: dosageData?.refill || "",
              patient_instruction: dosageData?.patient_instruction || "",
              dosage_instruction: dosageData?.text || "",
              time_instruction: timeInstruction?.find(
                (inst) =>
                  inst?.time_instCode === dosageData?.time_instruction_code
              ),
              duration: duration?.[0] || "",
              durationType: duration?.[1] || "",
              frequency: freqDetails?.[0] || "",
              period_info: freqDetails?.[1] || "",
              period_type: frequency?.[1] || "",
              dose: doseDetails?.[0] || "",
              dose_type: doseDetails?.[1] || "",
            };
          })
        );

        console.log({ transformed });

        // Add all transformed services to Redux if not already present
        transformed.forEach((service) => {
          const exists = servicesList.some((s) => s.id === service.id);
          if (!exists) {
            dispatch(
              handleAddPreauthorizationServices({
                type: "ADD_SERVICES",
                payload: service,
              })
            );
          }
        });
      } catch (error) {
        console.error("Error loading preauthorization services:", error);
      }
    };

    loadServices();
  }, [providerServices, stepFormData, selectedBranch, reuse, edit, followUp]);

  const handleView = (row) => {
    dispatch(setSelectedService(row));
    dispatch(setViewModal(true));
    dispatch(setHistoryModal(true));
  };

  const handleEdit = (row) => {
    dispatch(setSelectedService(row));
    dispatch(setHistoryModal(true));
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    console.log({ deleteId });
    if (deleteId) {
      dispatch(
        handleAddPreauthorizationServices({
          type: "DELETE_SERVICES",
          payload: { id: deleteId },
        })
      );
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const columns = [
    {
      name: "#",
      sortable: false,
      omit: false,
      selector: (_, index) => (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "20px", height: "20px" }}
          >
            {index + 1}
          </div>
        </div>
      ),
    },
    {
      name: "Date",
      sortable: false,
      omit: false,
      selector: (row) =>
        moment(row?.service_start_date).format("DD-MM-YYYY") || "",
    },
    {
      name: <div>Service Code / Description</div>,
      sortable: false,
      cell: (row) => {
        const code =
          row?.service_code_description?.value ||
          row?.service_code_description?.prodserv_code ||
          "";
        const desc =
          row?.service_code_description?.label ||
          row?.service_code_description?.prodserv_desc ||
          "";
        const providerCode = row?.service_code_description?.provider_code || "";
        const providerDesc =
          row?.service_code_description?.provider_codedesc || "";

        return (
          <div className="fs-11">
            <div className="text-primary">
              <strong>{code}</strong> - {desc}
            </div>
            {(providerCode || providerDesc) && (
              <div className="text-danger fs-11">
                {providerCode} - {providerDesc}
              </div>
            )}
          </div>
        );
      },
      width: "14rem",
    },
    {
      name: "Quantity",
      sortable: false,
      omit: false,
      selector: (row) => row?.quantity || 0,
    },
    {
      name: "Unit Price",
      sortable: false,
      omit: false,
      selector: (row) => row?.unit_price || 0,
    },
    {
      name: "Discount",
      sortable: false,
      omit: false,
      selector: (row) => row?.discount || 0,
    },
    {
      name: "Patient Share",
      sortable: false,
      omit: false,
      selector: (row) => row?.patient_share || 0,
    },
    {
      name: "Net Amount",
      sortable: false,
      omit: false,
      selector: (row) => row?.net_amount,
    },
    {
      name: <Gear />,
      button: true,
      allowOverflow: true,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <Eye
            onClick={() => handleView(row)}
            size={20}
            className="text-primary leaflet-interactive"
          />
          <Pen
            onClick={() => handleEdit(row)}
            size={20}
            className="text-warning leaflet-interactive"
          />
          <MdDelete
            onClick={() => handleDelete(row?.id)}
            size={20}
            className="text-danger leaflet-interactive"
          />
        </div>
      ),
    },
  ];

  console.log({ servicesList });

  return (
    <Row className="g-3">
      <Col xs={12} className="d-flex justify-content-end">
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            dispatch(resetSelectedService());
            dispatch(setHistoryModal(true));
          }}
        >
          <Plus size={18} /> Add Service
        </Button>
      </Col>

      <Col xs={12}>
        {servicesList?.length > 0 ? (
          <Col xs={12}>
            <DataTable
              data={servicesList}
              columns={columns}
              responsive
              customStyles={{
                table: { style: { overflow: "visible" } },
                rows: { style: { overflow: "visible" } },
              }}
            />
          </Col>
        ) : (
          <div className="border text-center py-3">No Service Found</div>
        )}
      </Col>

      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={confirmDelete}
        title="Delete Service"
        description="Are you sure you want to delete this service? This action cannot be undone."
      />
    </Row>
  );
};

export default ServicesProcedures;

export const timeInstruction = [
  { time_instCode: "BID", time_instDisplay: "Two time a day" },
  { time_instCode: "TID", time_instDisplay: "Three time a day" },
  { time_instCode: "QID", time_instDisplay: "Four time a day" },
  { time_instCode: "AM", time_instDisplay: "Every Morning" },
  { time_instCode: "PM", time_instDisplay: "Every Afternoon" },
  { time_instCode: "QD", time_instDisplay: "Every day" },
  { time_instCode: "QOD", time_instDisplay: "Every Other day" },
];
